// extracted by mini-css-extract-plugin
export var searchHeader = "_57-0";
export var searchHeaderDark = "_57-1";